// Which host is the *real* production app. Pure and runtime-agnostic (takes the hostname as a
// plain string, never touches window/self/navigator/location), so the identical check is safe to
// import from the browser (register.ts), the service worker (sw.ts), AND the Worker (preview gate).
//
// Production is the custom domain only — `bloomgarden.uk` and any subdomain of it (e.g.
// `admin.bloomgarden.uk`). Everything else is NON-production: the shared `*.workers.dev` PR-preview
// origin and `localhost`. On non-production origins we refuse to install a service worker (a shared
// preview URL would otherwise pin a stale precached shell forever) and we enable the one-tap preview
// sign-in. `endsWith(".bloomgarden.uk")` matches only true subdomains, not e.g. `evilbloomgarden.uk`.
export function isProductionHost(hostname: string): boolean {
  return hostname === "bloomgarden.uk" || hostname.endsWith(".bloomgarden.uk");
}
